import React from 'react'
import { Link } from 'react-router-dom'

const ButtonLink = ({route, children}) => {
  return (
    <Link to={route} className="btn btn--primary">{children}</Link>
  )
}

export default ButtonLink